import AOS from 'aos'
AOS.init({
    easing: 'ease-out-quart',
    duration: 1000
});